export default "__VITE_ASSET__BFQU1Sq9__"